/*eslint no-useless-constructor: "off"*/
import React, {Component} from 'react'
import NavBar from './../ui/template/NavBar'

class App extends Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    //Uncomment if you want to do a edirect
    //this.props.router.push('/fireadmin/clubs+skopje+items') //Path where you want user to be redirected initialy
  }
  render() {
    return (
      <div className="content">
        <NavBar/>

        Dashboard
        <br />
        Admin panel for Sahajyoga App . 
      </div>
    )
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js